import type { ReactNode } from "react"

import { PwaDeviceRegistrar } from "@/components/member/pwa-device-registrar"
import { Toaster } from "@/components/ui/sonner"
import { TimezoneProvider } from "@/contexts/timezone-context"
import { useFlash } from "@/hooks/use-flash"

interface PersistentLayoutProps {
  children: ReactNode
}

export default function PersistentLayout({ children }: PersistentLayoutProps) {
  useFlash()
  return (
    <TimezoneProvider>
      <PwaDeviceRegistrar />
      {children}
      <Toaster richColors />
    </TimezoneProvider>
  )
}
